<script setup>
import MediaImage from '@components/MediaImage.vue';

defineProps({
  uuid: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    required: true,
  },
  link: {
    type: String,
    required: true,
  },
  imageRatio: {
    type: Array,
    default: () => [ 290, 230 ],
  },
  width: {
    type: Number,
    default: 290,
  },
});
</script>

<template>
  <div class="contact-slide">
    <MediaImage
      :uuid="uuid"
      :ratio="imageRatio"
      :width="width"
      picture-class="contact-slide__picture"
      is-lazy-flickity
    />
    <div class="contact-slide__button">
      <a
        class="btn btn--primary btn--small"
        :href="link"
      >{{ text }}</a>
    </div>
  </div>
</template>
